import gql from 'graphql-tag';

const GET_NOTES = gql`
  query getNotes($ticketId: ID!) {
    getNotes(ticketId: $ticketId) {
      noteId
      content
      addedBy {
        userId
        firstName
        lastName
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_NOTE_LIST = gql`
  query getNoteList($input: GetNoteListInput!) {
    getNoteList(input: $input) {
      noteId
      content
      addedOn
      addedBy {
        userId
        firstName
        lastName
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      workItem {
        workId
        module
      }
      privacyType
    }
  }
`;

// const { todo } = client.readQuery({
//   query: gql`
//     query ReadTodo($id: Int!) {
//       todo(id: $id) {
//         id
//         text
//         completed
//       }
//     }
//   `,
//   variables: {
//     id: 5,
//   },
// });

export { GET_NOTES, GET_NOTE_LIST };
